module.exports = __webpack_public_path__ + "ba51f2ba424c001fc34cb7a2ee050571.svg";